import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {isConnectedCenterMode} from '../lib/nexus-connected-center';
import {getIsShowingProject} from '../reducers/project-state';
import {setProjectTitle} from '../reducers/project-title';

const getTitleFromUrl = () => {
    if (typeof location === 'undefined') {
        return '';
    }
    const raw = new URLSearchParams(location.search).get('cc_game_title');
    if (!raw) {
        return '';
    }
    try {
        return decodeURIComponent(raw).trim();
    } catch (e) {
        return raw.trim();
    }
};

const NexusCCProjectTitleHOC = function (WrappedComponent) {
    class NexusCCProjectTitleComponent extends React.Component {
        componentDidMount () {
            this.applyTitleFromUrl();
        }
        componentDidUpdate (prevProps) {
            if (!prevProps.isShowingProject && this.props.isShowingProject) {
                this.applyTitleFromUrl();
            }
        }
        applyTitleFromUrl () {
            if (!isConnectedCenterMode()) {
                return;
            }
            const title = getTitleFromUrl();
            if (title) {
                this.props.onSetProjectTitle(title);
            }
        }
        render () {
            return <WrappedComponent {...this.props} />;
        }
    }

    NexusCCProjectTitleComponent.propTypes = {
        isShowingProject: PropTypes.bool,
        onSetProjectTitle: PropTypes.func
    };

    const mapStateToProps = state => ({
        isShowingProject: getIsShowingProject(state.scratchGui.projectState.loadingState)
    });

    const mapDispatchToProps = dispatch => ({
        onSetProjectTitle: title => dispatch(setProjectTitle(title))
    });

    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(NexusCCProjectTitleComponent);
};

export default NexusCCProjectTitleHOC;
